import * as React from "react";
import { ReportStore } from "src/stores/ReportStore";
import { observer, inject } from "mobx-react";
import { errorMessage } from "../common/Toast";
import SimpleReportComponent from "./SimpleSaleReportComponent";

export interface Props {
    reportStore?: ReportStore;
}
export interface State {
    wasValidated: boolean;
    saleYear: string | null;
    reportContent: string;
}

@inject("reportStore")
@observer
export default class NewHorsesEnteredByYear extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            wasValidated: false,
            saleYear: null,
            reportContent: ""
        };
    }
    generateReport = async () => {
        try {
            if (this.state.saleYear) {
                const report = await this.props.reportStore!.getHorsesByYear(this.state.saleYear);
                this.setState({ reportContent: report });
            }
        } catch (error) {
            errorMessage(error);
        }
    };

    formValidation = (): boolean => {
        return this.state.saleYear !== null && this.state.saleYear !== "" ? true : false;
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (this.formValidation()) {
            this.setState({ wasValidated: false, reportContent: "" });
            this.generateReport();
        } else {
            this.setState({ reportContent: "", wasValidated: true });
        }
    };

    render() {
        return (
            <SimpleReportComponent
                title="New Horses Entered in The System by Year"
                wasValidated={this.state.wasValidated}
                onSubmit={this.submit}
                onChangeSelectYear={(year: string | null) => this.setState({ saleYear: year })}
                content={this.state.reportContent}
                year={this.state.saleYear}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/NewHorsesEnteredByYear.tsx